module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center001"
  }, [_c('b', [_vm._v("PRAISE FOR THE WRITING OF NERO BLANC")])]), _vm._v(" "), _c('p', {
    staticClass: "normal2"
  }, [_vm._v("“At last puzzle fans have their revenge … super sleuthing and solving for puzzle lovers and mystery fans.” —Charles Preston, puzzle editor, "), _c('i', [_vm._v("USA Today")])]), _vm._v(" "), _c('p', {
    staticClass: "normal2"
  }, [_vm._v("“Addicts of crossword puzzles will relish "), _c('i', [_vm._v("The Crossword Murder")]), _vm._v(".” —"), _c('i', [_vm._v("Chicago Sun-Times")])]), _vm._v(" "), _c('p', {
    staticClass: "normal2"
  }, [_vm._v("“A puzzle lover’s delight … A touch of suspense, a pinch of romance, and a whole lot of clever word clues … Blanc has concocted a story sure to appeal to crossword addicts and mystery lovers alike. What’s a three-letter word for this book? F-U-N.” —Earlene Fowler on "), _c('i', [_vm._v("The Crossword Murder")])]), _vm._v(" "), _c('p', {
    staticClass: "normal2"
  }, [_vm._v("“Snappy, well-plotted … an homage to Agatha Christie and Ngaio Marsh … The solid plot never strays from its course and features a surprising yet plausible ending.” —"), _c('i', [_vm._v("Fort Lauderdale Sun-Sentinel")]), _vm._v(" on "), _c('i', [_vm._v("Two Down")])]), _vm._v(" "), _c('p', {
    staticClass: "normal2"
  }, [_vm._v("“Another neat whodunit, along with some clever crosswords … Blanc builds the suspense slowly and surely, challenging the reader with a dandy puzzler.” —"), _c('i', [_vm._v("Publishers Weekly")]), _vm._v(" on "), _c('i', [_vm._v("The Crossword Connection")])]), _vm._v(" "), _c('p', {
    staticClass: "normal2"
  }, [_vm._v("“A great investigative team in the tradition of Nick and Nora … Nero Blanc is a master.” —BookBrowser")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65d1538a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/endmatter10.vue
// module id = 63
// module chunks = 0